module.exports = __webpack_public_path__ + "static/img/hexagon_icon_5.a5665e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/hexagon/hexagon_icon_5.png
// module id = x1bY
// module chunks = 1